import { useSignInWithAppleButton } from "src/auth/sdks/AppleAuthSdk";
import type { ReactNode } from "react";

export type AppleSignInProps = {
  children: (props: { signInWithApple: () => void }) => ReactNode;
};

export function AppleSignIn({ children }: AppleSignInProps) {
  const { signInWithApple } = useSignInWithAppleButton();

  return (
    <>
      {children({
        signInWithApple,
      })}
    </>
  );
}
